export default __webpack_public_path__ + "static/media/chevron_white.65b1fb40.svg";